function randomString(length = 16) {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return result;
}

function getCookies() {
  let cookies = document.cookie.split(";");

  cookies = cookies.map((string) => string.trim());

  const _cookies = {};
  cookies.forEach((cookie) => {
    const [key, value] = cookie.split("=");
    _cookies[key] = value;
  });

  return _cookies;
}

function toCamelCase(string) {
  return string
    .split("_")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}

function money(value) {
  return `R ${value.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export default {
  getCookies,
  toCamelCase,
  money,
  randomString,
};
